var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-width full-height " },
    [
      _c(
        "q-card-media",
        {
          staticClass: "cursor-pointer",
          nativeOn: {
            click: function($event) {
              return _vm.clickCard()
            }
          }
        },
        [
          _vm.library.image_original
            ? _c("img", { attrs: { src: _vm.library.image_original } })
            : _vm._e(),
          !_vm.library.image_original
            ? _c("img", { attrs: { src: _vm.getPlaceholder } })
            : _vm._e()
        ]
      ),
      _c("q-card-main", [
        _c(
          "p",
          {
            staticClass:
              "q-subheading text-weight-medium text-primary title-library"
          },
          [_vm._v(_vm._s(_vm.library.title))]
        ),
        _c("p", { staticClass: "text-faded q-mt-md" }, [
          _vm._v(
            _vm._s(_vm.$t("category")) +
              ": " +
              _vm._s(_vm.getCategory(_vm.library.category))
          )
        ]),
        _c("div", { staticClass: "tags-library q-mt-md" }, [
          _vm.library.tags.length > 0
            ? _c(
                "span",
                { staticClass: "text-faded" },
                [
                  _vm._v(_vm._s(_vm.$t("tags")) + ":\n                "),
                  _vm._l(_vm.library.tags, function(tag, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                    " + _vm._s(_vm.getTag(tag))
                      ),
                      _vm.library.tags.length - 1 > index
                        ? _c("span", [_vm._v(", ")])
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            : _vm._e()
        ])
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        {
          staticClass: "justify-center action-library",
          staticStyle: { height: "90px" }
        },
        [
          _c("q-btn", {
            attrs: { flat: "", label: _vm.library.size, icon: "fal fa-hdd" }
          }),
          _c("q-btn", {
            attrs: {
              flat: "",
              label: _vm.library.hits,
              icon: "fal fa-download"
            }
          }),
          _c("q-btn", {
            attrs: {
              flat: "",
              label: _vm.library.extension,
              icon: _vm.$extensionIcon(_vm.library.extension)
            }
          })
        ],
        1
      ),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        { staticClass: "justify-center" },
        [
          _c("q-btn", {
            staticClass: "full-width q-my-sm",
            attrs: {
              label: _vm.$t("open"),
              icon: "fal fa-eye",
              color: "secondary"
            },
            on: {
              click: function($event) {
                return _vm.clickCard()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }